module.exports = __webpack_public_path__ + "img/76282.f25ca125.svg";